package demos.`fun`

import androidx.compose.animation.core.Spring
import androidx.compose.animation.core.animateOffsetAsState
import androidx.compose.animation.core.spring
import androidx.compose.foundation.background
import androidx.compose.foundation.gestures.detectDragGestures
import androidx.compose.foundation.gestures.detectTapGestures
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.offset
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.BlurredEdgeTreatment
import androidx.compose.ui.draw.blur
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.layout.onGloballyPositioned
import androidx.compose.ui.layout.positionInWindow
import androidx.compose.ui.unit.IntOffset
import androidx.compose.ui.unit.dp
import kotlin.math.absoluteValue


const val MOTION_BLUR = "cd568e3a1f32b45d5763aac30d54613370f851536cd382e943cf3bf1f2199795"
@Composable
fun MotionBlur() {

    var offset by remember { mutableStateOf(Offset.Zero) }

    val animatedOffset by animateOffsetAsState(targetValue = offset, animationSpec = spring(stiffness = Spring.StiffnessLow))

    Box(
        Modifier
            .fillMaxSize()
            .pointerInput(
                Unit
            ) {
                detectTapGestures(
                    onTap = {
                        offset = it
                    }
                )
            }
            .pointerInput(
                Unit
            ) {
                detectDragGestures { change, dragAmount ->
                    offset += dragAmount
                }
            },
        contentAlignment = Alignment.TopStart,
    ) {


        var lastOffset by remember { mutableStateOf(Offset.Zero) }

        var blurX by remember { mutableStateOf(0f) }
        var blurY by remember { mutableStateOf(0f) }

        Box(Modifier
            .offset { IntOffset(animatedOffset.x.toInt(), animatedOffset.y.toInt()) }
            .onGloballyPositioned {
                val currentOffset = it.positionInWindow()
                blurY = ((currentOffset.y - lastOffset.y).absoluteValue) * .5f
                blurX = ((currentOffset.x - lastOffset.x).absoluteValue) * .5f
                lastOffset = currentOffset
            }
            .blur(
                radiusX = blurX.dp,
                radiusY = blurY.dp,
                edgeTreatment = BlurredEdgeTreatment.Unbounded,
            )
            .size(100.dp)
            .background(Color.White, CircleShape)
        )


    }
}